import * as Yup from "yup";

const regExp = new RegExp(/^(?=\S*[a-zA-Z])(?=\S*[0-9])(?=\S{8,})/);

// The v3 password contract (PLA-3258) caps a password at 512 characters. The
// min/letter/digit/whitespace rules below are kept lenient because this same
// validator gates sign-in, where the value is an existing password.
export const validatorPassword = Yup.string()
  .max(512, "Password must be 512 characters or fewer")
  .matches(regExp, {
    excludeEmptyString: true,
    message:
      "Password must have a minimum of 8 characters, include at least 1 digit and 1 letter and cannot include spaces"
  });
